import { render } from "./storeBanner.vue?vue&type=template&id=53dd95c8&scoped=true"
import script from "./storeBanner.vue?vue&type=script&lang=js"
export * from "./storeBanner.vue?vue&type=script&lang=js"

import "./storeBanner.vue?vue&type=style&index=0&id=53dd95c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53dd95c8"]])

export default __exports__